import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { useCaseListQuerySchema } from "@kansai-ai-hub/schema";

import { EnterpriseActivePage } from "@/features/enterprise/active-page";
import { deriveActiveFilters } from "@/features/enterprise/active-filters";
import { casesListQueryOptions, toCaseListFilters } from "@/features/cases/queries";
import { STATIC_LABELS } from "@/lib/nav-registry";

// 案件フィルタ（CaseFilters）と共通の検索スキーマに統一。view のみ UI 専用パラメータ。
const activeSearchSchema = useCaseListQuerySchema.extend({
  view: z.enum(["grid", "table"]).default("grid"),
});

export const Route = createFileRoute("/_authenticated/enterprise/active/")({
  staticData: { crumb: { label: STATIC_LABELS.enterpriseActive } },
  validateSearch: activeSearchSchema,
  // view はサーバーへ送らない UI パラメータ。statuses 未指定は自社の全ステータス
  // （下書き / 停止中を含む）に解決する（deriveActiveFilters）。
  loaderDeps: ({ search }) => ({
    ...toCaseListFilters(search),
    statuses: deriveActiveFilters(search.statuses).statuses,
  }),
  // ロールガードは親 layout (`enterprise/route.tsx`) が ENTERPRISE 限定。
  loader: async ({ context, deps }) => {
    await context.queryClient.ensureQueryData(casesListQueryOptions(deps));
  },
  component: EnterpriseActivePage,
});
